import Model from "../Model";
import Attribute from "./Attribute";

export default class DateAttribute extends Attribute {

  public createAttribute(parentModel: Model, json) {
    return json[this.name] ? new Date(json[this.name]) : null;
  }

}